<template>
  <div class="live-stream-info-container ticker-wrap">
    <div class="ticker-move">
      <div class="ticker-item">Live stream starts at {{formattedStartTime}}</div>
    </div>
  </div>
</template>
<script>

import moment from 'moment'
export default {
  props: ['item'],
  computed: {
    formattedStartTime () {
      const m = moment(this.item.liveInfo.YOUTUBE_LIVE_SCHEDULED_START_TIME)
      return m.format('MMM Do YYYY, h:mm a')
    }
  }

}
</script>
